import User from 'User/Infrastructure/Translation/es';
import Permission from 'Permission/Infrastructure/Translation/es';
import PermissionGroup from 'PermissionGroup/Infrastructure/Translation/es';
import OrgChart from 'OrgChart/Infrastructure/Translation/es';
import ScheduledCommand from 'ScheduledCommand/Infrastructure/Translation/es';
import Security from 'Shared/Security/Infrastructure/Translation/es';
import UI from 'UI/Infrastructure/Translation/es';
import ProposalProject from 'ProposalProject/ProposalProject/Infrastructure/Translation/es';
import DelegationService from 'DelegationService/DelegationService/Infrastructure/Translation/es';
import AfterSalesExtra from 'Extra/AfterSalesExtra/Infrastructure/Translation/es';

export const es = {
    ...User,
    ...Permission,
    ...PermissionGroup,
    ...OrgChart,
    ...ScheduledCommand,
    ...Security,
    ...UI,
    ...ProposalProject,
    ...DelegationService,
    ...AfterSalesExtra,
};